<template>
    <div id="that">
        <div style="padding: 10px 0px 0px 0px">
            <van-icon name="arrow-left" style="float: left" size="20px" @click="onback"/>
        </div>
        <div style="height: 40px"></div>

        <van-dropdown-menu>
            <van-dropdown-item v-model="MaintainPicture.id" :options="maintainpeList" @change="changeMenu"/>
        </van-dropdown-menu>

        <van-divider
                :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
        >
            维修前
        </van-divider>
        <div style="margin-left: 20px;text-align: center">
            <row>
<!--            <van-uploader disabled multiple v-model="beforePics" name="1" :after-read="afterRead" :before-delete="deletePic">-->
            <van-uploader multiple v-model="beforePics" name="1" :after-read="afterRead" :before-delete="deletePic">
            </van-uploader>
            </row>

            <row>
            <Button type="info" style="margin-right: 5px;" @click="uploadbeforePics(1)">选择图片</Button>
            <Button type="info" @click="restart">刷新</Button>
            </row>
        </div>


        <van-divider
                :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }"
        >
            维修后
        </van-divider>
        <div style="margin-left: 20px;text-align: center">
            <row>
<!--            <van-uploader disabled multiple v-model="afterPics" name="2" :after-read="afterRead" :before-delete="deletePic">-->
            <van-uploader multiple v-model="afterPics" name="2" :after-read="afterRead" :before-delete="deletePic">
            </van-uploader>
            </row>
            <row>
                <Button type="info" style="margin-right: 5px;" @click="uploadbeforePics(2)">选择图片</Button>
                <Button type="info" @click="restart">刷新</Button>
            </row>
        </div>
        <van-overlay :show="showOverlay" @click="showOverlay = false">
            <van-loading size="90" style="padding-top: 200px" color="#1989fa;" />
        </van-overlay>
    </div>
</template>

<script>
    const wx = require('weixin-js-sdk')
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,
        Overlay,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

    export default {
        name: "maintainOrders-UploaderImage-vant",
        data() {
            return {
                showOverlay: false,

                value1: 0,
                maintainpeList: [
                    // { text: '全部商品', value: 0 },
                    // { text: '新款商品', value: 1 },
                    // { text: '活动商品', value: 2 },
                ],

                afterPics: [],


                beforePics: [],

                MaintainPicture:{
                    id:0,
                    picKey:null,
                    picType:null,
                    srcWidth:null,
                    srcHeight:null,
                },
            }
        },
        methods: {
            restart(){
                this.loadingPic();
                // this.reload();
            },
            uploadbeforePics(e){
                console.log(e)
                var appid = 'wx35df9038a4f73847'
                var noncestr = 'maintainOrders-UploaderImage-vant' + Date.parse(new Date()) / 1000
                var timestamp = Date.parse(new Date()) / 1000
                // let url = location.href.split('#')[0]
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let url = ''
                if (isAndroid) {
                    url = location.href
                }
                Vue.prototype.href = window.location.href
                if (isIOS) {
                    url = window.location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
                }
                store.dispatch('MediaPlatformServ_GetSignature', {
                    urlparams: {
                        noncestr: noncestr,
                        timestamp: timestamp,
                        url: url,
                    }
                }).then(res => {
                    console.log(res)
                    // alert(res.data)
                    wx.config({
                        debug: false,
                        appId: appid,
                        timestamp: timestamp,
                        nonceStr: noncestr,
                        signature: res.data,
                        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
                            'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData', 'checkJsApi'],
                        success: function (res) {
                            console.log(res)
                        },
                        fail: function (err) {
                            console.log(err)
                        }
                    });
                }).catch(err => {
                    console.log(err)
                })

                let that = this
                wx.ready( function () {
                    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                    wx.chooseImage({
                        count: 9, // 默认9
                        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                        isShowProcess: 1,
                        success:  function (res) {
                            console.log(res)
                            console.log(res.localIds.length)
                            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                            for (let i=0; i<=res.localIds.length-1; i++) {
                                console.log(i)
                                setTimeout( function timer() {
                                    //调用wx.getLocalImgData 获取base64 及转换成二进制 上传到七牛 绑定key到数据库
                                    that.uploadbefore(res.localIds[i],e);
                                    // that.loadingPic();
                                    // that.reload();
                                }, i*1000, i );
                            }
                        },
                        fail: function (err) {
                            console.log(err)
                        }
                    });
                });
                wx.error(function (res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    console.log(res)
                });


            },

                uploadbefore(localIds,e) {
                    let that = this
                    wx.getLocalImgData({
                        localId: localIds,
                        success:  function (res) {
                            console.log('预览图片成功')
                            const localData = res.localData;
                            let imageBase64 = '';
                            console.log('转换成base64')
                            if (localData.indexOf('data:image') == 0) {
                                //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                                imageBase64 = localData;
                                console.log(imageBase64)
                            } else {
                                //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                                //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                                imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                                console.log(imageBase64)
                            }
                            console.log('base64转换成二进制')
                            let dataurltoblob = dataURLtoBlob(imageBase64)
                            console.log(dataurltoblob)

                            //获取七牛上传凭证
                            store.dispatch('PictureServ_GetQiniuUploadToken', {
                                params: {
                                    head: 'MAINTAINORDER'
                                },
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                                let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                                handleAvatar(dataurltoblob, uploadToken, photoKey, e)
                            }).catch((err) => {
                                console.log(err)
                                this.errorlog('七牛错误' + err)
                            })

                            /**
                             * base64转为可post的二进制数据
                             */
                            function dataURLtoBlob(dataurl) {
                                let arr = dataurl.split(',');
                                let mime = arr[0].match(/:(.*?);/)[1];
                                let bstr = atob(arr[1]);
                                let n = bstr.length;
                                let u8arr = new Uint8Array(n);
                                while (n--) {
                                    u8arr[n] = bstr.charCodeAt(n);
                                }
                                return new Blob([u8arr], {
                                    type: mime
                                });
                            }

                            /**
                             * ajax上传图片
                             */
                            function handleAvatar(imageBase64, uploadToken, photoKey,e) {
                                console.log(imageBase64)
                                console.log(uploadToken)
                                console.log(photoKey)
                                var param = new FormData();
                                // param.append('headPic', imageBase64);
                                param.append('file', imageBase64);
                                param.append('chunk', '0');//断点传输
                                param.append('chunks', '1');
                                param.append('token', uploadToken)
                                param.append('key', photoKey);
                                let config = {
                                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                                    // headers:{'Content-Type':'application/json'},
                                    headers: {'Content-Type': 'multipart/form-data'},
                                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                                    withCredentials: false
                                };

                                let MaintainPicture = {
                                    id: null,
                                    picKey: null,
                                    picType: null,
                                    srcWidth: null,
                                    srcHeight: null,
                                    upload_token: null,
                                    picKey: null,
                                }
                                MaintainPicture.id = that.MaintainPicture.id
                                MaintainPicture.picType = e.toString()
                                MaintainPicture.srcWidth = imageBase64.srcWidth
                                MaintainPicture.srcHeight = imageBase64.srcHeight
                                MaintainPicture.upload_token = uploadToken
                                MaintainPicture.picKey = photoKey

                                axios.post('https://upload-z2.qiniup.com', param, config)
                                    .then(response => {
                                        console.log(response);
                                        console.log(response.data);
                                        // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                                        // console.log(this.addPictureRecord)
                                        //  未完成的订单
                                        //安装订单更换图片
                                        store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
                                            params:
                                            MaintainPicture
                                            ,
                                            urlparams: null
                                        }).then((res) => {
                                            console.log(res)
                                            Toast.success('添加图片成功')
                                            that.loadingPic()
                                            /**
                                             * 异步调用导致列表长度不对，无法正常点击table打开图片
                                             */
                                            // this.loadPhotoRecords(this.maintainOrderid)
                                        }).catch(err => {
                                            Toast(err)
                                            console.log(err)
                                        });
                                    }).catch(err1 => {

                                    Toast(err1)
                                    // this.loadingStatus = false
                                })


                            };
                        },
                        fail: function (err) {
                            console.log(err)
                        },
                        complete: function (res) {
                            console.log(res)
                        }
                    });
                },

            //返回上一页
            onback() {
                this.$router.push({
                    name: 'maintainOrdersDetail',
                    params: {'maintainOrdersDetailid': this.$route.query.maintainOrdersUploaderimage}
                })
            },
            deletePic(file, e) {
                // console.log(e)
                // console.log(file)
                this.$Modal.confirm({
                    title: '确认删除',
                    content: '<p>确认删除</p>',
                    onOk: () => {
                        store.dispatch('MaintainOrderServ_RemoveMaintainPicture', {
                            params: {maintainPictureId: file.id}
                        }).then(() => {
                            this.$Message.success('删除成功')
                            this.loadingPic()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            async afterRead(file, e) {
                this.showOverlay = true
                // Toast('开始')
                this.show = true
                // console.log(e)
                // console.log(file)
                this.MaintainPicture.picType = e.name
                if (file.length>1){

                    file.forEach(async (item, index) => {
                        //获取七牛上传凭证
                        await store.dispatch('PictureServ_GetQiniuUploadToken', {
                            params: {
                                head: 'MAINTAINORDER' + index
                            },
                            urlparams: null
                        }).then(async (res) => {
                            console.log(res)
                            let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                            let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                            // that.uploadFile.push({item,uploadToken,photoKey})
                            await this.vanupload(item.file, uploadToken, photoKey)
                        }).catch((err) => {
                            console.log(err)
                            this.errorlog('七牛错误' + err)
                        })
                        if (index == (file.length - 1)) {
                            this.showOverlay = false
                            this.loadingPic()
                        }
                    })
                }else {
                    //获取七牛上传凭证
                    store.dispatch('PictureServ_GetQiniuUploadToken', {
                        params: {
                            head: 'MAINTAINORDER'
                        },
                        urlparams: null
                    }).then(async (res) => {
                        console.log(res)
                        let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                        let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                        // that.uploadFile.push({item,uploadToken,photoKey})
                        await this.vanupload(file.file, uploadToken, photoKey)
                        this.showOverlay = false
                        this.loadingPic()
                    }).catch((err) => {
                        console.log(err)
                        this.errorlog('七牛错误' + err)
                    })
                }
            },
            async vanupload(file, uploadToken, photoKey) {
                let param = new FormData(); //创建form对象
                param.append('chunk', '0');//断点传输
                param.append('chunks', '1');
                param.append('token', uploadToken)
                param.append('key', photoKey);
                param.append('file', file, file.name)
                let config = {
                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                    // headers:{'Content-Type':'application/json'},
                    headers: {'Content-Type': 'multipart/form-data'},
                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                    withCredentials: false
                };

                let MaintainPicture = {
                    id: null,
                    picKey: null,
                    picType: null,
                    srcWidth: null,
                    srcHeight: null,
                    upload_token: null,
                    picKey: null,
                }
                MaintainPicture.id = this.MaintainPicture.id
                MaintainPicture.picType = this.MaintainPicture.picType
                MaintainPicture.srcWidth = file.srcWidth
                MaintainPicture.srcHeight = file.srcHeight
                MaintainPicture.upload_token = uploadToken
                MaintainPicture.picKey = photoKey

                await axios.post('https://upload-z2.qiniup.com', param, config)
                        .then(response => {
                            console.log(response);
                            console.log(response.data);
                            // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                            // console.log(this.addPictureRecord)
                            //  未完成的订单
                            //安装订单更换图片
                            store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
                                params:
                                MaintainPicture
                                ,
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                Toast.success('添加图片成功')
                                // this.loadingPic()
                                /**
                                 * 异步调用导致列表长度不对，无法正常点击table打开图片
                                 */
                                // this.loadPhotoRecords(this.maintainOrderid)
                            }).catch(err => {
                                Toast(err)
                                console.log(err)
                            });
                        }).catch(err1 => {

                        Toast(err1)
                        console.log(err1)
                    })

            },
            changeMenu(name) {
                // console.log(name)
                this.loadingPic()
            },
            loadingPic() {
                this.afterPics = []
                this.beforePics = []
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {id: this.$route.query.maintainOrdersUploaderimage},
                    urlparams: null
                }).then(() => {
                    // console.log(store.getters.get_MaintainOrder_GetDetailResult)
                    if (store.getters.get_MaintainOrder_GetDetailResult) {
                        if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                            store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                                if (this.MaintainPicture.id == item.id) {
                                    item.afterPics.forEach(afterPicsItem => {
                                        this.afterPics.push({
                                            id: afterPicsItem.id,
                                            url: 'https://pic.jianchengjt.com/' + afterPicsItem.picKey + '?imageView2',
                                            isImage: true
                                        })
                                    })
                                    item.beforePics.forEach(beforePicsItem => {
                                        this.beforePics.push({
                                            id: beforePicsItem.id,
                                            url: 'https://pic.jianchengjt.com/' + beforePicsItem.picKey + '?imageView2',
                                            isImage: true
                                        })
                                    })
                                }
                            })
                        }
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                console.log(this.$route.query.maintainOrdersUploaderimage)
                let id = this.$route.query.maintainOrdersUploaderimage
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {id: id},
                    urlparams: null
                }).then(() => {
                    console.log(store.getters.get_MaintainOrder_GetDetailResult)
                    if (store.getters.get_MaintainOrder_GetDetailResult) {
                        if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                            store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                                this.maintainpeList.push({
                                    text: item.terminalNum.toString(), value: item.id
                                })
                                this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
                            })
                            this.loadingPic()
                        }
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            })
        },
    }
</script>

<style scoped>
    #that {
        height: 100%;
        width: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
